export default __webpack_public_path__ + "static/media/github-icon.04ed74f3.svg";